import 'slick-carousel';
import debounce from 'lodash/debounce';
import EqualHeights from 'utils/EqualHeights';

$(window).on('load', () => {
  const containers = document.querySelectorAll('.js-image-section-cards');

  if (containers !== null) {
    Array.forEach(containers, (container) => {
      // eslint-disable-next-line
      new EqualHeights(container, '.js-card-title');  

      window.addEventListener('resize', debounce(() => initialiseCarousel(container), 500));

      initialiseCarousel(container);
    });
  }

  function initialiseCarousel(container) {
    if (container.classList.contains('slick-initialized')) {
      return;
    }

    const id = container.getAttribute('data-id');

    $(container).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      centerMode: false,
      infinite: false,
      arrows: true,
      draggable: true,
      appendArrows: document.querySelector(`[data-carousel-id="${id}"]`),
      mobileFirst: true,
      prevArrow: '<div aria-label="Previous" class="card-carousel-button card-carousel-button--previous"><span class="sr-only">Previous</span></div>',
      nextArrow: '<div aria-label="Next" class="card-carousel-button card-carousel-button--next"><span class="sr-only">Next</span></div>',
      responsive: [{
        breakpoint: 991,
        settings: 'unslick',
      }],
    });
  }
});
